import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/** Base path for receptionist or hospital-admin front-desk routes. */
export function useFrontDeskBasePath(): '/receptionist' | '/hospital-admin' {
  const location = useLocation();
  if (location.pathname.startsWith('/hospital-admin')) return '/hospital-admin';
  return '/receptionist';
}

export function useIsFrontDeskStaff(): boolean {
  const { user } = useAuth();
  return (
    user?.role === 'RECEPTIONIST' ||
    user?.role === 'OPERATIONS_MANAGER' ||
    user?.role === 'HOSPITAL_ADMIN'
  );
}

export function useIsReceptionistOnly(): boolean {
  const { user } = useAuth();
  return user?.role === 'RECEPTIONIST';
}

/** Reception / hospital admin may edit IPD & day care front-desk flows. Operations Manager is view-only. */
export function useCanMutateFrontDeskIpd(): boolean {
  const { user } = useAuth();
  return (
    user?.role === 'RECEPTIONIST' ||
    user?.role === 'HOSPITAL_ADMIN' ||
    user?.role === 'SUPER_ADMIN'
  );
}

/** Open, pay, cancel, or close draft outpatient bills (OPD / lab / pharma / additional). */
export function useCanFinalizeOutpatientDraftBill(): boolean {
  const { user } = useAuth();
  return (
    user?.role === 'RECEPTIONIST' ||
    user?.role === 'OPERATIONS_MANAGER' ||
    user?.role === 'PHARMACIST' ||
    user?.role === 'SALES_PERSON' ||
    user?.role === 'SALES_MANAGER' ||
    user?.role === 'HOSPITAL_ADMIN' ||
    user?.role === 'SUPER_ADMIN'
  );
}
